import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

const notificationQueue = [];
let isShowingNotification = false;

/**
 * Danger-toast suppression for the synchronous cancel-cascade that follows a
 * route change. When navigation aborts in-flight GETs, their catch blocks fire
 * "error" toasts on a page that no longer exists. Suppressing danger toasts for
 * exactly one macrotask covers that microtask cascade while leaving real,
 * network-latency errors on the new page (which arrive many ticks later)
 * unaffected — so no genuine error message is ever hidden.
 */
let suppressDangerToasts = false;
export const suppressNavigationToasts = () => {
  suppressDangerToasts = true;
  setTimeout(() => {
    suppressDangerToasts = false;
  }, 0);
};

export const toasterMsg = (message, getVariant, duration, icon) => {
  if (suppressDangerToasts && getVariant === "danger") {
    return;
  }
  // Check if the message is already in the queue
  const existingMessageIndex = notificationQueue?.findIndex((item) => item.message === message);
  // If the message is already in the queue, update its duration
  if (existingMessageIndex !== -1) {
    const existingMessage = notificationQueue[existingMessageIndex];
    existingMessage.duration = duration || existingMessage.duration;
  } else {
    // Add the notification details to the queue
    notificationQueue.push({
      message,
      getVariant,
      duration,
      icon,
    });
  }
  if (!isShowingNotification) {
    showNextNotification();
  }
};

const showNextNotification = () => {
  if (notificationQueue.length > 0) {
    const { message, getVariant, duration } = notificationQueue.shift();
    isShowingNotification = true;
    Store.addNotification({
      title: 'Bombiix PLM',
      message,
      type: getVariant,
      insert: 'top',
      container: 'top-right',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'fadeOut'],
      dismiss: {
        duration: duration || 3000,
      },
      onRemoval: () => {
        isShowingNotification = false;
        showNextNotification(); // Show the next notification in the queue, if any
      },
    });
  }
};
